<template>
    <div class="row pt-3">
        <div class="col-12">
            <div class="table-responsive">
                <table class="table qf-table">
                    <thead>
                    <tr>
                        <th class="qf-w-100px">Logo</th>
                        <th>
                            <a href="#!" class="d-inline-flex align-items-center"
                               @click.prevent="changeSort('title')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='title' && tableFilter.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='title' && tableFilter.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Trademark')}}
                                </div>
                            </a>
                        </th>
                        <th>
                            <a href="#!" class="d-inline-flex align-items-center"
                               @click.prevent="changeSort('representative')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='representative' && tableFilter.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='representative' && tableFilter.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Representative')}}
                                </div>
                            </a>
                        </th>
                        <th>
                            <a href="#!" class="d-inline-flex align-items-center"
                               @click.prevent="changeSort('owner')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='owner' && tableFilter.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='owner' && tableFilter.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Owner')}}
                                </div>
                            </a>
                        </th>
                        <th>
                            <a href="#!" class="d-inline-flex align-items-center"
                               @click.prevent="changeSort('type')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='type' && tableFilter.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='type' && tableFilter.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Type')}}
                                </div>
                            </a>
                        </th>
                        <th>
                            <a href="#!" class="d-inline-flex align-items-center"
                               @click.prevent="changeSort('contestation')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='contestation' && tableFilter.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (tableFilter.sort.field==='contestation' && tableFilter.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Contestation')}}
                                </div>
                            </a>
                        </th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-if="loadingResults">
                        <td colspan="6" class="p-5 h2">
                            <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
                        </td>
                    </tr>
                    <tr v-for="singleResult in results"
                        :key="`result${singleResult.id}`"
                        class="qf-clickable"
                        @click="showDetails(singleResult.id)"
                        v-else>
                        <td class="py-3 qf-mw-100px">
                            <img :src="`${$store.state.baseUrl}${singleResult.logo}`"
                                 alt="" v-if="singleResult.logo !== undefined"
                                 class="img-fluid">
                        </td>
                        <td class="py-3">
                            {{singleResult.title}}
                        </td>
                        <td class="py-3">
                            {{singleResult.representative}}
                        </td>
                        <td class="py-3">
                            {{singleResult.owner}}
                        </td>
                        <td class="py-3">
                            {{singleResult.type}}
                        </td>
                        <td class="py-3">
                            {{singleResult.contestation | dateFormat}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "SearchResults",
        props: {
            results: Array,
            tableFilter: Object,
            loadingResults: Boolean
        },
        methods: {
            changeSort(field) {
                this.$emit('changeSort', field);
            },
            showDetails(id) {
                this.$router.push({name: 'SingleSearchResult', params: {id: id}})
            }
        }
    }
</script>

<style scoped>

</style>
